// extracted by mini-css-extract-plugin
export default {"chartPage":"ChartPage_chartPage__T8mek","chartContainer":"ChartPage_chartContainer__fpJR1","error":"ChartPage_error__otPjK"};